import { render } from "./SpaceItem.vue?vue&type=template&id=21cf8224"
import script from "./SpaceItem.vue?vue&type=script&lang=js"
export * from "./SpaceItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__